import React from 'react';
import { Grid, Typography } from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import style from "./../../assets/styles/componentStyles/userProfileStyles/userProfileStyle.module.scss";

interface EmailAddressDisplayProps {
    email?: string | null;
}

const EmailAddressDisplay: React.FC<EmailAddressDisplayProps> = ({ email }) => (
    <Grid item xs={12}>
        <Grid container className={style.emailAddressBanner} alignItems="center" flexWrap="nowrap" gap="8px">
            <EmailOutlinedIcon className={style.emailAddressBannerIcon} />
            <Typography className={style.emailAddressBannerLabel} component="span">
                Email Address:
            </Typography>
            <Typography className={style.emailAddressBannerValue} component="span">
                {email || "-"}
            </Typography>
        </Grid>
    </Grid>
);

export default EmailAddressDisplay;
